<template>
  <!--
    Casca persistente do módulo App: o Layout (navbar + sidebar) monta UMA vez
    e só o miolo (router-view) troca ao navegar entre telas do módulo.
    As páginas filhas NÃO devem embrulhar <Layout> — apenas o conteúdo.
  -->
  <Layout>
    <router-view />
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'

export default {
  name: 'app-shell',
  components: { Layout }
}
</script>
